<app-shared-dialog class="ui-dialog" [options]="{ hideHeader: true, hideActions: true, size: 'medium' }">
  <app-company-location-selector
    [company]="data?.company ?? null"
    [location]="data?.location ?? null"
    [canGoBack]="data?.canGoBack ?? true"
    [mode]="data?.mode ?? 'new'"
    [orderId]="data?.order_id"
    [targetId]="data?.targetId ?? null"
    [initialStep]="data?.initialStep"
    [prefillLocation]="data?.prefillLocation"
    (completed)="onCompleted($event)"
    (cancelled)="onCancelled()">
  </app-company-location-selector>
</app-shared-dialog>
